import { useSelector } from "react-redux";
import useCheckItemDetails from "./useCheckItemDetails";
import { RootState } from "../../../../store/store";

export default function TaskDetails({ item }) {
  const { inspectionTaskLinks } = useSelector((state: RootState) => state.InspectionTaskLinks)
  const filteredInspectionTaskLinks = inspectionTaskLinks.filter((link) => link.inspectionTaskId === item.inspectionTaskId);
  const injectionTaskLinks = { ...item, link: filteredInspectionTaskLinks }
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } = useCheckItemDetails({ item: injectionTaskLinks });
  return (
    <div className="flex flex-col">
      <table {...getTableProps()} className="text-sm w-fit">
        <thead>
          {headerGroups.map(headerGroup => {
            const { key, ...restProps } = headerGroup.getHeaderGroupProps();
            return (
              <tr key={key} {...restProps}>
                {headerGroup.headers.map(column => {
                  const { key, ...restProps } = column.getHeaderProps();
                  return (
                    <th className="px-6" key={key} {...restProps}>
                      {column.render("Header")}
                    </th>
                  );
                })}
              </tr>
            );
          })}
        </thead>
        <tbody {...getTableBodyProps()}>
          {rows.map(row => {
            prepareRow(row);
            const { key, ...restProps } = row.getRowProps();
            return (
              <tr key={key} {...restProps}>
                {row.cells.map((cell, index) => {
                  const { key, ...restProps } = cell.getCellProps();
                  const cellClass = index === 0 ? "font-bold whitespace-nowrap pr-28 py-2" : "py-2";
                  return (
                    <td className={cellClass} key={key} {...restProps}>
                      <div className="flex capitalize ">{cell.render("Cell")}</div>
                    </td>
                  );
                })}
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}